/** The `push` area: web push notifications (src/domain/push.ts), formatted in
 *  the recipient's locale, and what a follow adds for push. */
export const push = {
  'push.title.untitled': 'Untitled',
  'push.body.requesterWalkedAway': 'Requester walked away',
  'push.body.deliveryDenied': 'Work denied',
  'push.body.needsAttention': 'Needs your attention',
  /** A subscribed push whose event fired no signal: the act, in the feed's
   *  word for it ({act}, `feed.action.*`, a lowercase label), after a colon.
   *  The title names the item; no person is named. */
  'push.body.act': 'New on this item: {act}',
  'push.body.decisionAwaits': 'A decision awaits you',
  /** A seat offered to the recipient, read as an assignment (the title names
   *  the item): who offers, then the seat's plain label ({role},
   *  `feed.offer.role.*`); "Someone" where the offerer has no name. */
  'push.body.actorOfferedSeat': '{actor} assigned you an item: {role}',
  'push.body.offeredSeat': 'Someone assigned you an item: {role}',
  /** The recipient named in the item's prose (docs/PROSE.md §5.4): who named
   *  them and the item ({item}, its title); "Someone" where the namer has no
   *  name. */
  'push.body.actorNamedYou': '{actor} named you in {item}',
  'push.body.namedYou': 'Someone named you in {item}',
  // What Subscribe adds for push, one sentence per follow floor.
  'push.follow.everyEvent': 'Also pages you on every event.',
  'push.follow.notices': 'Also pages you on notices and above.',
  'push.follow.warnings': 'Also pages you on warnings and above.',
  'push.follow.criticals': 'Also pages you on criticals.',
} as const;
